import { useEffect } from "react"

const EnterKeyClickHandler = () => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key !== "Enter") return
            const activeElement = document.activeElement as HTMLElement | null
            if (!activeElement) return
            const tagName = activeElement.tagName.toLowerCase()
            const isTextArea = tagName === "textarea"
            const isContentEditable = activeElement.getAttribute("contenteditable") === "true"

            if (isTextArea || isContentEditable) {
                return
            }

            const loginForm = document.getElementById("login-form")
            if (loginForm && loginForm.contains(activeElement)) {
                return
            }

            const hasTabIndex = activeElement.hasAttribute("tabindex")
            const isDisabled =
                (activeElement as HTMLInputElement).disabled ||
                activeElement.getAttribute("aria-disabled") === "true"

            if (hasTabIndex && !isDisabled && typeof activeElement.click === "function") {
                activeElement.click()
                e.preventDefault()
            }
        }

        document.addEventListener("keydown", handleKeyDown)
        return () => document.removeEventListener("keydown", handleKeyDown)
    }, [])

    return null
}

export default EnterKeyClickHandler
